import z from 'zod';

/** Disburse escrow funds */
export const DisburseEscrowFundsTaskSettingsType = z.enum(['ALL', 'ESCROWED_ONLY']);
export type DisburseEscrowFundsTaskSettingsType = z.infer<typeof DisburseEscrowFundsTaskSettingsType>;

export const DisburseEscrowFundsTaskSettings = z.object({
  enabled: z.boolean().default(true),
  type: DisburseEscrowFundsTaskSettingsType.default('ALL'),
  notifyEscrowBeforeDays: z.number().int().positive().default(45),
  notifyNonEscrowBeforeDays: z.number().int().positive().default(10),
  dueDateDays: z.number().int().positive().default(5),
});
export type DisburseEscrowFundsTaskSettings = z.infer<typeof DisburseEscrowFundsTaskSettings>;
export const DEFAULT_DISBURSE_ESCROW_FUNDS_TASK_SETTINGS: DisburseEscrowFundsTaskSettings = {
  enabled: true,
  type: 'ALL',
  notifyEscrowBeforeDays: 45,
  notifyNonEscrowBeforeDays: 10,
  dueDateDays: 5,
};

/** ---------------------------- */
export const CompanyTaskSettings = z.object({
  pastGraceEnabled: z.boolean(),
  loanFlaggedTooLongEnabled: z.boolean(),
  forwardMiscollectedFundsEnabled: z.boolean(),
  mailPreActiveWelcomeLetterEnabled: z.boolean(),
  mailMonthlyStatementEnabled: z.boolean(), // Should be mailStatementEnabled
  mailGoodbyeLetterEnabled: z.boolean(),
  mailMortgageeLetterEnabled: z.boolean(),
  disburseEscrowFunds: DisburseEscrowFundsTaskSettings.default(DEFAULT_DISBURSE_ESCROW_FUNDS_TASK_SETTINGS),
  disburseMortgageInsuranceEscrowFundsEnabled: z.boolean(),
  disburseMortgageInsuranceNonEscrowedEnabled: z.boolean(),
  generatePayoffStatementEnabled: z.boolean(),
  achPaymentFailedEnabled: z.boolean(),
  generateManualStatementEnabled: z.boolean().default(false),
  welcomeCallTaskEnabled: z.boolean().default(false),
  lienReleaseEnabled: z.boolean().default(false),
});

export type CompanyTaskSettings = z.infer<typeof CompanyTaskSettings>;

export const DEFAULT_COMPANY_TASK_SETTINGS: CompanyTaskSettings = {
  pastGraceEnabled: true,
  loanFlaggedTooLongEnabled: true,
  forwardMiscollectedFundsEnabled: true,
  mailPreActiveWelcomeLetterEnabled: true,
  mailMonthlyStatementEnabled: true,
  mailGoodbyeLetterEnabled: true,
  mailMortgageeLetterEnabled: true,
  disburseMortgageInsuranceEscrowFundsEnabled: false,
  disburseEscrowFunds: DEFAULT_DISBURSE_ESCROW_FUNDS_TASK_SETTINGS,
  disburseMortgageInsuranceNonEscrowedEnabled: false,
  generatePayoffStatementEnabled: true,
  achPaymentFailedEnabled: false,
  generateManualStatementEnabled: false,
  welcomeCallTaskEnabled: false,
  lienReleaseEnabled: false,
};
